import ExcelJS from 'exceljs';
import { MetadataFieldNames } from './../../types/common';
const initializeExcelWorkbook = (anchorDoc, comparisonDocs, documentsComparisonDetail) => {
    var _a;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Comparison Export');
    let anchorTitle = anchorDoc.fileName;
    const anchorMetadata = documentsComparisonDetail.documents.find(dm => { var _a; return ((_a = dm.find(m => m.name === MetadataFieldNames.filename)) === null || _a === void 0 ? void 0 : _a.value) === anchorDoc.fileName; });
    const formTitle = (_a = anchorMetadata === null || anchorMetadata === void 0 ? void 0 : anchorMetadata.find(m => m.name === MetadataFieldNames.formTitle)) === null || _a === void 0 ? void 0 : _a.value;
    if (formTitle)
        anchorTitle += ` - ${formTitle}`;
    worksheet.addRow(['', anchorTitle, ...comparisonDocs.map(doc => {
            var _a;
            let docTitle = doc.fileName;
            const docMetadata = documentsComparisonDetail.documents.find(dm => { var _a; return ((_a = dm.find(m => m.name === MetadataFieldNames.filename)) === null || _a === void 0 ? void 0 : _a.value) === doc.fileName; });
            const formTitle = (_a = docMetadata === null || docMetadata === void 0 ? void 0 : docMetadata.find(m => m.name === MetadataFieldNames.formTitle)) === null || _a === void 0 ? void 0 : _a.value;
            if (formTitle)
                docTitle += ` - ${formTitle}`;
            return docTitle;
        })]);
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { horizontal: 'center' };
    return { workbook, worksheet };
};
const initializeClassificationColumnsInRow = (anchorDoc, comparisonDocs, classificationName) => {
    const classificationColumnsInRow = [];
    const clauses = anchorDoc.classificationMap.get(classificationName);
    classificationColumnsInRow.push(clauses || []);
    comparisonDocs.forEach(doc => {
        const clauses = doc.classificationMap.get(classificationName);
        classificationColumnsInRow.push(clauses || []);
    });
    return classificationColumnsInRow;
};
const initializeExcelRows = (classificationName, topLevelClassificationRow, totalClassificationColumns) => {
    const maxNestedClassificationCount = getMaxNestedClassificationCount(topLevelClassificationRow);
    const excelRows = Array(maxNestedClassificationCount).fill(null).map(() => Array(totalClassificationColumns).fill(null).map(() => ({ richText: [{ text: '' }] })));
    excelRows[0].splice(0, 1, { richText: [{ text: classificationName }] });
    return excelRows;
};
const getMaxNestedClassificationCount = (columns) => {
    return columns.reduce((num, clauses) => {
        let have = 0;
        clauses.forEach(clause => {
            if (clause.classifications.length) {
                have += 1;
            }
        });
        return have > num ? have : num;
    }, 0);
};
export { initializeExcelWorkbook, initializeClassificationColumnsInRow, initializeExcelRows, };
